<template>
    <div class="">
        404 Not Found
    </div>
</template>

<script>
export default {
    name: "NotFound",
};
</script>